"use strict";

var _slicedToArray = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collectSegmentInfo = exports.mergeSegments = exports.Segment = void 0;

var util_1 = require("./util");

var Segment = /*#__PURE__*/function () {
  function Segment(start, end, inferStart, id) {
    _classCallCheck(this, Segment);

    this.start = start;
    this.end = end;
    this.inferStart = inferStart;
    this.id = id;
    this.blocks = [{
      start: start,
      binary: []
    }];
    this.curBlock = this.blocks[0];
  }

  _createClass(Segment, [{
    key: "setCurrentPC",
    value: function setCurrentPC(pc) {
      var err = undefined;

      if (this.inferStart && this.blocks.length === 1 && this.blocks[0].binary.length === 0) {
        this.start = pc;
      } else {
        var endstr = this.end !== undefined ? "$".concat(util_1.toHex16(this.end)) : '';
        var range = "Segment address range: $".concat(util_1.toHex16(this.start), "-").concat(endstr);

        if (pc < this.start) {
          err = "".concat(range, ".  Cannot set program counter to a lower address $").concat(util_1.toHex16(pc), ".");
        } else {
          if (this.end !== undefined && pc > this.end) {
            err = "".concat(range, ".  Trying to set program counter to $").concat(util_1.toHex16(pc), " -- it is past segment end ").concat(endstr, ".");
          } else {
            if (this.blocks.length === 1 && this.blocks[0].binary.length === 0) {
              this.start = pc;
            }
          }
        }
      }

      var newBlock = {
        start: pc,
        binary: []
      };
      var idx = this.blocks.push(newBlock);
      this.curBlock = this.blocks[idx - 1];
      return err;
    }
  }, {
    key: "empty",
    value: function empty() {
      return this.blocks.every(function (b) {
        return b.binary.length === 0;
      });
    }
  }, {
    key: "currentPC",
    value: function currentPC() {
      return this.curBlock.start + this.curBlock.binary.length;
    }
  }, {
    key: "emit",
    value: function emit(byte) {
      if (this.currentPC() < this.start || this.end !== undefined && this.currentPC() > this.end) {
        var endstr = this.end !== undefined ? "$".concat(util_1.toHex16(this.end)) : '';
        var startstr = this.start !== undefined ? "$".concat(util_1.toHex16(this.start)) : '';
        return "Segment overflow at $".concat(util_1.toHex16(this.currentPC()), ".  Segment address range: ").concat(startstr, "-").concat(endstr);
      }

      this.curBlock.binary.push(byte);
      return undefined;
    }
  }, {
    key: "formatRange",
    value: function formatRange() {
      var endstr = this.end !== undefined ? "$".concat(util_1.toHex16(this.end)) : '';
      var startstr = this.start !== undefined ? "$".concat(util_1.toHex16(this.start)) : '';
      return "".concat(startstr, "-").concat(endstr);
    }
  }, {
    key: "overlaps",
    value: function overlaps(another) {
      var startA = this.start;
      var startB = another.start;
      var endA = this.end !== undefined ? this.end : this.currentPC();
      var endB = another.end !== undefined ? another.end : another.currentPC();

      if (startA < startB) {
        return startB <= endA;
      }

      return endB >= startA;
    }
  }]);

  return Segment;
}();

exports.Segment = Segment;

function compact(segments) {
  var out = [];

  var _iterator = _createForOfIteratorHelper(segments),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          name = _step$value[0],
          seg = _step$value[1];

      var compactBlocks = seg.blocks.filter(function (b) {
        return b.binary.length !== 0;
      }).sort(function (a, b) {
        return a.start - b.start;
      });

      if (compactBlocks.length !== 0) {
        var newSeg = new Segment(seg.start, seg.end, seg.inferStart, out.length - 1);
        newSeg.blocks = compactBlocks;
        newSeg.curBlock = compactBlocks[compactBlocks.length - 1];
        out.push([name, newSeg]);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return out;
}

function mergeSegments(segments_) {
  var segments = compact(segments_);

  if (segments.length === 0) {
    return {
      startPC: 0,
      binary: Buffer.from([])
    };
  }

  var _segments$ = _slicedToArray(segments[0], 2),
      _ = _segments$[0],
      s0 = _segments$[1];

  var block0 = s0.blocks[0];
  var blockN = s0.blocks[s0.blocks.length - 1];
  var minAddr = block0.start;
  var maxAddr = blockN.start + blockN.binary.length;

  for (var i = 1; i < segments.length; i++) {
    var s = segments[i][1];
    var firstPC = s.blocks[0].start;
    var lastPC = s.curBlock.start + s.curBlock.binary.length;
    minAddr = Math.min(firstPC, minAddr);
    maxAddr = Math.max(lastPC, maxAddr);
  }

  var buf = Buffer.alloc(maxAddr, 0);

  var _iterator2 = _createForOfIteratorHelper(segments),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          _2 = _step2$value[0],
          seg = _step2$value[1];

      var _iterator3 = _createForOfIteratorHelper(seg.blocks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var b = _step3.value;
          Buffer.from(b.binary).copy(buf, b.start);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return {
    startPC: minAddr,
    binary: buf.slice(minAddr)
  };
}

exports.mergeSegments = mergeSegments;

function collectSegmentInfo(segments_) {
  var segments = compact(segments_).sort(function (a, b) {
    return a[1].start - b[1].start;
  });
  return segments.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        s = _ref2[1];

    var blocks = s.blocks.map(function (b) {
      return {
        start: b.start,
        end: b.start + b.binary.length - 1
      };
    });
    return {
      name: name,
      blocks: blocks
    };
  });
}

exports.collectSegmentInfo = collectSegmentInfo;